
import { useMapEvents, Polyline } from 'react-leaflet';
import { useState, useEffect, useRef } from "react";
import * as turf from '@turf/turf';
import L from "leaflet";
import { groupMarkersByVetka, groupMarkersByCanton } from '../TerritoryFilter/GroupMarkersPolygon';
import { getPolygonPoints2 } from '../Drawing/LinePolygons';

const MarkerPoligonToClickDistance = ({ 
  switchesData, marker, markers, setMarkers, 
  coordinates, setCoordinates, selectedCanton, housesData 
}) => {
  const [currentLine, setCurrentLine] = useState(null); // Временная линия до курсора
  const tooltipRef = useRef(null);

  const markersByVetka = groupMarkersByVetka(housesData);
  const markersByCanton = groupMarkersByCanton(switchesData);

  useEffect(() => {
    // Создаём кастомный tooltip
    tooltipRef.current = L.DomUtil.create("div", "custom-draw-tooltip");
    tooltipRef.current.style.position = "absolute";
    tooltipRef.current.style.background = "linear-gradient(to bottom, #727272, #a7a7a7)";
    tooltipRef.current.style.color = "#fcc205";
    tooltipRef.current.style.fontSize = "12px";
    tooltipRef.current.style.fontWeight = "bold";
    tooltipRef.current.style.padding = "1px 4px";
    tooltipRef.current.style.borderRadius = "4px";
    tooltipRef.current.style.boxShadow = "0 0 6px rgba(0,0,0,0.2)";
    tooltipRef.current.style.pointerEvents = "none";
    tooltipRef.current.style.zIndex = "1000";
    tooltipRef.current.style.display = "none";

    document.body.appendChild(tooltipRef.current);
    
    return () => {
      if (tooltipRef.current) {
        document.body.removeChild(tooltipRef.current);
      }
    };
  }, []);

  useMapEvents({
    click: (e) => {
            if (marker) {
              const { lat, lng } = e.latlng;
              setMarkers([...markers, { lat, lng }]);
              
              const point = turf.point([lng, lat]);
              let foundInPolygon = false;
              let polygonInfo = 'вне области полигона';
              let flagTerritory;
      
        Object.keys(markersByCanton).forEach((canton) => {
          const coordinates = markersByCanton[canton];
          const polygonPoints = getPolygonPoints2(coordinates);
          if (polygonPoints) {
            const polygon = turf.polygon([polygonPoints.map(coord => [coord[1], coord[0]])]);
            if (turf.booleanPointInPolygon(point, polygon)) {
              foundInPolygon = true;
              polygonInfo = `${canton}`;
              flagTerritory = "canton";
            }
          }
        });

        Object.keys(markersByVetka).forEach((vetka) => {
          const coordinates = markersByVetka[vetka];
          const polygonPoints = getPolygonPoints2(coordinates);
          if (polygonPoints) {
            const polygon = turf.polygon([polygonPoints.map(coord => [coord[1], coord[0]])]);
            if (turf.booleanPointInPolygon(point, polygon)) {
              foundInPolygon = true;
              polygonInfo = `${vetka}`;
              flagTerritory = "area";
            }
          }
        });

        if (!foundInPolygon) {
          polygonInfo = selectedCanton;
          flagTerritory = "city";
        }

        setCoordinates([...coordinates, { lat, lng, polygonInfo, flagTerritory }]);
      }
    },

    mousemove: (e) => {
      if (marker && markers.length > 0) {
        const lastMarker = markers[markers.length - 1];
        const { lat, lng } = e.latlng;

        setCurrentLine([[lastMarker.lat, lastMarker.lng], [lat, lng]]);

        const from = turf.point([lastMarker.lng, lastMarker.lat]);
        const to = turf.point([lng, lat]);
        const options = { units: "meters" };
        const distance = turf.distance(from, to, options);
        
       

        if (tooltipRef.current) {
          tooltipRef.current.style.left = `${e.originalEvent.pageX + 10}px`;
          tooltipRef.current.style.top = `${e.originalEvent.pageY + 10}px`;
          tooltipRef.current.innerHTML = `${distance.toFixed(1)} м`;
          tooltipRef.current.style.display = "block";
        }
      }
    },

    mouseout: () => {
      setCurrentLine(null);
     

      if (tooltipRef.current) {
        tooltipRef.current.style.display = "none";
      }
    }
  });

  return (
    <>
      { marker && currentLine && (
        <Polyline positions={currentLine} color="gray" dashArray="5, 5"  weight={0.8}></Polyline>
      )}
    </>
  );
};

export default MarkerPoligonToClickDistance;


// const MarkerPoligonToClick = ({ switchesData, marker, markers, setMarkers, coordinates, setCoordinates, selectedCanton, housesData }) => {

//   const markersByVetka = groupMarkersByVetka(housesData);
//   const markersByCanton = groupMarkersByCanton(switchesData);


//   useMapEvents({
//     click: (e) => {
//       if (marker) {
//         const { lat, lng } = e.latlng;
//         setMarkers([...markers, { lat, lng }]);
        
//         const point = turf.point([lng, lat]);
//         let foundInPolygon = false;
//         let polygonInfo = 'вне области полигона';
//         let flagTerritory;

//         Object.keys(markersByCanton).forEach((canton) => {
//           const coordinates = markersByCanton[canton];
//           const polygonPoints = getPolygonPoints2(coordinates);
//           if (polygonPoints) {
//             const polygon = turf.polygon([polygonPoints.map(coord => [coord[1], coord[0]])]);
//             if (turf.booleanPointInPolygon(point, polygon)) {
//               foundInPolygon = true;
//               polygonInfo = `${canton}`;
//               flagTerritory = 'canton';
//             }
//           }
//         });

//         Object.keys(markersByVetka).forEach((vetka) => {
//           const coordinates = markersByVetka[vetka];
//           const polygonPoints = getPolygonPoints2(coordinates);
//           if (polygonPoints) {
//             const polygon = turf.polygon([polygonPoints.map(coord => [coord[1], coord[0]])]);
//             if (turf.booleanPointInPolygon(point, polygon)) {
//               foundInPolygon = true;
//               polygonInfo = `${vetka}`;
//               flagTerritory = 'area';
//             }
//           }
//         });

//         if (!foundInPolygon) {
//           polygonInfo = selectedCanton;
//           flagTerritory = 'city';
//         }

//         setCoordinates([...coordinates, { lat, lng, polygonInfo, flagTerritory }]);
//       }
//     },
//   });
//   return null;
// };

// export default MarkerPoligonToClick;
